/**
 * form-job.js starts
 * Created by mac on 04.09.2018.
 */

$(function () {
  
  var $btnjob = $('.job-response-btn'),
      formjob = document.getElementById('job-form-wrapper');
  
  if (formjob) {
    var vacfield = formjob.querySelector('input[name=vacancy]'),
        vactitle = formjob.querySelector('.vacancy-title');
  }
  
  $btnjob.on('click', function (e) {
    var vacancy = e.target.dataset.vacancy;
    
    vacfield.value     = vacancy;
    vactitle.innerText = vacancy;
    Wf.slowScroll(formjob, 500, 180);
    
    e.preventDefault();
  });
  
});

/* form-job.js ends */